var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.59 7L6 2.67341L1.41 7L-1.16446e-07 5.66802L6 -4.29138e-07L12 5.66802L10.59 7Z",
    fill: "#508CC0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpPrimary);
export default __webpack_public_path__ + "static/media/arrow-up-primary.f7a2917e00b3953962325ec18f8b410f.svg";
export { ForwardRef as ReactComponent };